import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import BaseModal from "./BaseModal";
import Grid from "@mui/material/Grid";
import { Alert } from "@mui/material";
import SessionTypeSelect from "components/forms/SessionTypeSelect";
import { formatSessionTypes, parseSessionTypes } from "services/RankingFilterHelper";

/**
 * Modifica del valore del filtro "Sessione": uno o più tipi di leg.
 * onSubmit riceve il formato del server, es. "0|1|3".
 */
export default function EditSessionTypesModal({ open, onClose, onSubmit, defaultValue, infoMessage, warningMessage }) {

    const { t } = useTranslation();
    const [value, setValue] = useState(parseSessionTypes(defaultValue));
    const [error, setError] = useState(null);

    useEffect(() => {
        if (open) setValue(parseSessionTypes(defaultValue));
    }, [open]);

    function submit() {
        if (value.length === 0) {
            setError(t('mandatoryField'));
            return;
        }
        onSubmit(formatSessionTypes(value));
        setError(null);
        onClose();
    }

    return <BaseModal open={open} onClose={onClose} onSave={submit}>
        {infoMessage &&
            <Grid item xs={12} style={{ marginBottom: "0.5rem", padding: "16px" }}>
                <Alert variant="outlined" severity="info">{infoMessage}</Alert>
            </Grid>
        }
        {warningMessage &&
            <Grid item xs={12} style={{ marginBottom: "0.5rem", padding: "16px" }}>
                <Alert variant="outlined" severity="warning">{warningMessage}</Alert>
            </Grid>
        }
        <Grid container spacing={4} style={{ margin: 0, width: "100%", marginBottom: "1rem" }}>
            <SessionTypeSelect xs={12} label={t('sessionType')} value={value}
                onTextChange={(v) => { setValue(v); setError(null) }}
                error={error} />
            <div style={{ width: "15rem" }} />
        </Grid>
    </BaseModal>
}
